import { Routes, Route, Navigate } from "react-router-dom";


import Warehousing from "./Warehousing";

const warehousingRoutes = [
    {routeName: 'temperature-controlled-ambient' , component: <Warehousing/>},
    {routeName: 'records-management' , component: <Warehousing/>},
    {routeName: 'value-added-services' , component: <Warehousing/>},
    {routeName: 'primary-secondary-distribution' , component: <Warehousing/>},
    
];

const WarehousingRoutes = () => {
    return (
    <Routes>
       {warehousingRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default WarehousingRoutes;